type MastercardProps = {
  size?: number;
};

export function Mastercard({ size = 20 }: MastercardProps): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlSpace='preserve'
      width={size * 1.8}
      height={size}
      viewBox='0 0 152.4 108'
    >
      <path
        d='M0 0h152.4v108H0z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M60.4 25.7h31.5v56.6H60.4z'
        style={{
          fill: '#ff5f00',
        }}
      />
      <path
        d='M62.4 54c0-11 5.1-21.5 13.7-28.3-15.6-12.3-38.3-9.6-50.6 6.1C13.3 47.4 16 70 31.7 82.3c13.1 10.3 31.4 10.3 44.5 0C67.5 75.5 62.4 65 62.4 54z'
        style={{
          fill: '#eb001b',
        }}
      />
      <path
        d='M134.4 54c0 19.9-16.1 36-36 36-8.1 0-15.9-2.7-22.2-7.7 15.6-12.3 18.3-34.9 6-50.6-1.8-2.2-3.8-4.3-6-6 15.6-12.3 38.3-9.6 50.5 6.1 5 6.3 7.7 14.1 7.7 22.2z'
        style={{
          fill: '#f79e1b',
        }}
      />
    </svg>
  );
}
